import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { Reveal } from "./Reveal";
import { scrollToId } from "@/lib/scroll";
import { TRIMS } from "@/constants/options";

const SILVER_IMG = "/images/trim-xse.jpg";

const TrimImageCard = ({ img, alt, tag, title, testId, className = "" }) => (
    <motion.div
        data-testid={testId}
        className={`group relative overflow-hidden ${className}`}
        whileHover="hover"
    >
        <motion.img
            src={img}
            alt={alt}
            className="h-full w-full object-cover"
            variants={{ hover: { scale: 1.05 } }}
            transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/10 to-transparent" />
        <div className="absolute bottom-0 left-0 p-8">
            <p className="text-xs font-bold uppercase tracking-[0.3em] text-[#2563EB]">{tag}</p>
            <p className="mt-2 font-display text-2xl font-bold uppercase tracking-tight sm:text-3xl">
                {title}
            </p>
        </div>
    </motion.div>
);

export const Trims = () => (
    <section id="trims" data-testid="trims-section" className="bg-[#080808] py-28 sm:py-36">
        <div className="mx-auto max-w-7xl px-6">
            <Reveal className="flex flex-wrap items-end justify-between gap-6">
                <div>
                    <p className="mb-4 flex items-center gap-3 text-xs font-bold uppercase tracking-[0.35em] text-[#2563EB]">
                        <span className="h-2 w-2 rotate-45 bg-[#2563EB]" aria-hidden="true" />
                        The lineup
                    </p>
                    <h2 className="max-w-2xl font-display text-3xl font-extrabold uppercase leading-[1.02] tracking-tighter sm:text-5xl">
                        Every 2026 trim. Members choose first.
                    </h2>
                </div>
                <p className="max-w-sm text-base leading-relaxed text-zinc-400 md:text-lg">
                    Hybrid Electric Vehicle or Plug-in Hybrid Electric Vehicle across six trims,
                    base or fully loaded — your allocation, your specification.
                </p>
            </Reveal>

            <div className="mt-16 grid grid-cols-1 gap-6 md:grid-cols-12">
                <Reveal className="md:col-span-12" delay={0.1}>
                    <TrimImageCard
                        img={SILVER_IMG}
                        alt="2026 RAV4 XLE Premium in Ruby Flare Pearl driving along a coastal highway"
                        tag="Club favourite"
                        title="XLE Premium"
                        testId="trim-card-xle-premium"
                        className="h-[420px] md:h-[560px]"
                    />
                </Reveal>
                <Reveal className="md:col-span-12" delay={0.15}>
                    <div
                        data-testid="trim-list-card"
                        className="flex flex-col gap-8 border border-white/10 bg-[#050505] p-8 md:flex-row md:items-center md:justify-between"
                    >
                        <div>
                            <h3 className="font-display text-2xl font-bold uppercase tracking-tight sm:text-3xl">
                                Six trims. One fee.
                            </h3>
                            <div className="mt-5 flex flex-wrap gap-2" data-testid="trim-pills">
                                {TRIMS.map((trim) => (
                                    <span
                                        key={trim}
                                        className="border border-white/15 px-4 py-2 text-xs font-semibold uppercase tracking-[0.15em] text-zinc-300 transition-colors duration-300 hover:border-[#2563EB] hover:text-white"
                                    >
                                        {trim}
                                    </span>
                                ))}
                            </div>
                        </div>
                        <button
                            data-testid="trims-join-button"
                            onClick={() => scrollToId("join")}
                            className="group flex shrink-0 items-center gap-3 border border-white/25 px-8 py-4 text-sm font-bold uppercase tracking-[0.2em] transition-colors duration-300 hover:border-[#2563EB] hover:bg-[#2563EB]"
                        >
                            Pick your trim
                            <ArrowUpRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1 group-hover:-translate-y-1" />
                        </button>
                    </div>
                </Reveal>
            </div>
        </div>
    </section>
);
